export const SkeltonView: React.FC = () => {
  return (
    <div className="animate-pulse">
      <div className="flex flex-wrap justify-center">
        {Array(20)
          .fill(0)
          .map((_, i) => (
            <div key={i}>
              <div className="m-4 w-[120px] h-[170px] bg-gray-200 shadow-flier"></div>
            </div>
          ))}
      </div>
    </div>
  )
}
